<template>
  <v-container>
    <v-row>
      <v-col>
        <OrderDocumentationForm
            ref="orderDocumentation"
            hide-button
            @closeDialog="() => {$emit('dialogClosed')}"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import OrderDocumentationForm from '@/modules/book/views/task/components/OrderDocumentationForm.vue';

export default {
  name: 'CreateOrderStep',
  components: {OrderDocumentationForm},
  data() {
    return {
      inputData: {}
    }
  },
  methods: {
    setInputData(inputData) {
      this.inputData = inputData;
      this.$refs.orderDocumentation.setInputData(inputData);
    },
    save() {
      this.$refs.orderDocumentation.save();
    },
    cancelDialog() {
      this.$refs.orderDocumentation.clearForm();
      this.inputData = {}
    }
  }
}
</script>